import * as R from 'ramda';
import { ActionType } from '../../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, makeApiReducer, ApiReducer } from '../../../core/api/rsaa';
import { Endpoints } from '../../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../../core/api/module';
import { AppState } from '../../../core/redux/appState';


const KEY_ACTION = ActionType.PasswordRequirementMessageRequest;
const ACTIONS    = [
  ActionType.PasswordRequirementMessageRequest,
  ActionType.PasswordRequirementMessageResponse,
  ActionType.PasswordRequirementMessageError,
];


type Payload = string;


/**
 * Dispatch this action to submit and set the current user's self-selected new password
 */
export const passwordRequirementMessageAction = makeApiAction<Payload>({
  method: 'POST',
  endpoint: Endpoints.PasswordRequirements,
  headers: {
    'content-type': 'application/json',
    'accept': 'application/json',
  },
  body: (state: AppState) => JSON.stringify({
    userId:     state.auth.currentUser?.userId,
    languageId: state.locale.lang.languageId,
  }),
  types: makeRsaaTypes<Payload>(ACTIONS),
  bailout: state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['auth', 'passwordRequirementMessage'], payload, successState);
};


export const passwordRequirementMessageReducer = makeApiReducer<Payload>(ACTIONS, KEY_ACTION, reducer);
